import differenceInMinutes from 'date-fns/differenceInMinutes';

export default function getTextForDebitCard(localStorageData) {
    const { date: cardOrderDate } = localStorageData;
    const minutesFromOrderDate = differenceInMinutes(new Date(), new Date(cardOrderDate));
    const oneDayInMinutes = 1440;
    const twoWeeksInMinutes = 20160;

    if (minutesFromOrderDate <= oneDayInMinutes) {
        return 'firstDay';
    } else if (minutesFromOrderDate <= twoWeeksInMinutes) {
        return 'nextDays';
    }

    return 'moreTwoWeeks';
}
